<template>
    <div class="container-fluid activities">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "Activities"
    }
</script>

<style lang="scss">
    .activities {
        @apply mx-3 my-8;
        @screen md {
            @apply mx-10;
        }
    }
</style>